export const modalTitle = {
    rename: 'Rename flow',
};
